
<template>
  <div class="index-card-root mt-1">
    <v-sheet class="index-card-wrap d-flex justify-center align-center" flat color="transparent">
      <v-container :fluid="fluid" class="index-card-container">
        <v-card
          class="index-card"
          flat
        >
          <div class="index-card__header">
            <div class="index-card__header-content d-flex justify-space-between align-center flex-wrap">
              <slot name="header" />
            </div>
          </div>

          <!-- Área de busca / filtros -->
          <div
            v-if="$slots.subheader || $slots.subheader_append"
            class="index-card__toolbar"
          >
            <div
              v-if="$slots.subheader"
              class="index-card__toolbar-row d-flex justify-space-between align-center flex-wrap"
            >
              <slot name="subheader" />
            </div>
            <div
              v-if="$slots.subheader_append"
              class="index-card__toolbar-append"
            >
              <slot name="subheader_append" />
            </div>
          </div>

          <!-- Carregamento -->
          <div
            v-if="loading"
            class="index-card__loading"
          >
            <div class="index-card__loading-inner d-flex flex-column align-center justify-center">
              <span class="index-card__loading-label mb-4">Carregando dados…</span>
              <v-progress-circular
                indeterminate
                :size="48"
                :width="4"
                color="primary"
              />
            </div>
          </div>

          <!-- Conteúdo (tabela) -->
          <div
            v-else
            class="index-card__main"
          >
            <slot name="data_table" />
          </div>
        </v-card>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'IndexCard',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    fluid: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/*
 * Gradiente cinza (paleta Material blue-grey) + faixa vermelha na base do header.
 */
.index-card-root {
  --index-card-radius: 12px;
  --index-card-brand: #ed1c24;
  --index-card-g1: #607d8b;
  --index-card-g2: #546e7a;
  --index-card-g3: #455a64;
  --index-card-g4: #37474f;
}

.index-card-container {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

@media (min-width: 600px) {
  .index-card-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

.index-card {
  border-radius: var(--index-card-radius);
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.index-card__header {
  padding: 16px 20px;
  background: linear-gradient(
    125deg,
    var(--index-card-g1) 0%,
    var(--index-card-g2) 38%,
    var(--index-card-g3) 78%,
    var(--index-card-g4) 100%
  );
  border-bottom: 3px solid var(--index-card-brand);
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.07);
}

.index-card__header-content {
  gap: 12px;
}

.index-card__toolbar {
  background-color: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.index-card__toolbar-row {
  padding: 14px 18px 10px;
  gap: 12px;
}

.index-card__toolbar-append {
  padding: 0 18px 14px;
}

.index-card__loading {
  min-height: 40vh;
  background: #fafafa;
}

.index-card__loading-inner {
  min-height: inherit;
  padding: 32px 16px;
}

.index-card__loading-label {
  font-size: 0.9375rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.54);
}

.index-card__main {
  background: #fff;
}

.index-card__main >>> .v-data-table {
  border-radius: 0 !important;
}
</style>
